/* v91 (24 Oct 2026): "Manage my booking" — /pages/book?manage=<number>&t=<token>.
   Riders move or cancel their own demo / hire / half-day booking. The Hub emails this link
   ("Send change / cancel link" on its booking panel); the page also remembers the rider's last
   booking in this browser and offers the link on the booking page.
   Hub calls (App Proxy):
     GET  /hold/<n>?t=            the booking (valid while status is hold or confirmed; otherwise 404)
     POST /hold/<n>/move          { t, start, end? }  -> the booking with its new dates
     POST /hold/<n>/cancel        { t, why? }         -> the booking, status cancelled (free-demo code released by the Hub)
   The Hub enforces every rule and its error text is shown as it comes. Loads after yb-1..5. */
(function(){
  if (typeof S === 'undefined' || typeof api !== 'function' || !document.getElementById('yeti-booking')) return;

  var KEY = 'yb-last-booking';
  function remember(n, t, end){ try { if (n && t) localStorage.setItem(KEY, JSON.stringify({ n: n, t: t, end: end || '' })); } catch(e){} }
  function recall(){ try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch(e){ return null; } }
  function forget(){ try { localStorage.removeItem(KEY); } catch(e){} }
  function manageUrl(n, t){ return '/pages/book?manage=' + encodeURIComponent(n) + '&t=' + encodeURIComponent(t); }
  window.ybRemember = remember;
  window.ybManageUrl = manageUrl;

  var st = document.createElement('style');
  st.textContent =
    '#yeti-booking .yb-mg-panel{border:1px solid rgba(0,0,0,.14);border-radius:12px;padding:16px 18px;margin:14px 0;background:#fff;color:#1c1c1c}' +
    '#yeti-booking .yb-mg-panel h3{margin:0 0 6px;font-size:16px}' +
    '#yeti-booking .yb-mg-acts{display:flex;flex-wrap:wrap;gap:10px;margin:18px 0 4px}' +
    '#yeti-booking .yb-mg-ok{border-radius:10px;padding:12px 14px;margin:14px 0;background:#e6f4f1;color:#1c1c1c;border:1px solid #9fd3cb}' +
    '#yeti-booking .yb-mg-nav{display:flex;justify-content:space-between;align-items:center;margin:6px 0}' +
    '#yeti-booking .yb-mg-nav button{background:none;border:1px solid rgba(0,0,0,.2);border-radius:8px;padding:4px 12px;cursor:pointer;color:#1c1c1c}' +
    '#yeti-booking .yb-mg-nav button[disabled]{opacity:.35;cursor:default}' +
    '#yeti-booking .yb-day.mg-off{opacity:.35;cursor:default}' +
    '#yeti-booking .yb-day.mg-old{outline:2px dashed rgba(0,0,0,.35);outline-offset:-3px}' +
    '#yeti-booking .yb-mg-slots{display:flex;flex-wrap:wrap;gap:8px;margin:8px 0}' +
    '#yeti-booking .yb-mg-slots button{border:1px solid rgba(0,0,0,.2);background:#fff;color:#1c1c1c;border-radius:999px;padding:7px 14px;cursor:pointer;font:inherit;font-size:14px}' +
    '#yeti-booking .yb-mg-slots button.on{background:#1c1c1c;color:#fff;border-color:#1c1c1c}' +
    '#yeti-booking .yb-mg-why{width:100%;margin:8px 0 4px}' +
    '#yeti-booking .yb-mg-bar{display:flex;flex-wrap:wrap;gap:6px 14px;align-items:center;justify-content:space-between;border:1px solid rgba(0,0,0,.14);border-radius:10px;padding:10px 14px;margin:0 0 14px;background:#fff;color:#1c1c1c;font-size:14px}' +
    '#yeti-booking .yb-mg-bar a{font-weight:600;color:#1c1c1c;text-decoration:underline}' +
    '#yeti-booking .yb-mg-link{display:inline-block;margin-top:10px;font-size:14px;color:#1c1c1c;text-decoration:underline}';
  document.head.appendChild(st);

  function nDays(a, b){ return Math.round((dParse(b) - dParse(a)) / 864e5) + 1; }
  function bikeNames(h){ return (h.bikes || []).map(function(b){ return b && b.name ? b.name : String(b); }); }
  function kindLabel(h){ return h.kind === 'slot' ? 'Half-day ride' : h.kind === 'hire' ? 'Hire' : 'Demo'; }
  function isFree(h){ return h.kind !== 'hire' && !(h.totalCents > 0); }
  function whenTxt(h){
    if (h.kind === 'slot') return fmt(h.start) + ', ' + hm(h.slot_start) + '–' + hm(h.slot_end);
    var n = nDays(h.start, h.end);
    return (h.start === h.end ? fmt(h.start) : fmt(h.start) + ' → ' + fmt(h.end)) + ' · ' + n + (n === 1 ? ' day' : ' days');
  }
  function paidTxt(h){
    if (isFree(h)) return 'Free demo';
    return money(h.totalCents || 0) + (h.status === 'hold' ? ' — not paid yet' : ' — paid');
  }
  function errText(e){ return esc((e && e.message) || 'Something went wrong — please try again, or message us.'); }

  /* ── A link back to the rider's own booking, on the ordinary booking page ── */
  function offerLast(){
    var r = recall(); if (!r) return;
    if (r.end && r.end < iso(today())) { forget(); return; }
    api('/hold/' + encodeURIComponent(r.n) + '?t=' + encodeURIComponent(r.t)).then(function(h){
      if (!h || h.status !== 'confirmed') { if (h && h.status && h.status !== 'hold') forget(); return; }
      var wrap = document.querySelector('#yeti-booking .yb-wrap'), at = document.getElementById('yb-stepper');
      if (!wrap || !at || document.getElementById('yb-mg-bar')) return;
      var bar = document.createElement('div'); bar.id = 'yb-mg-bar'; bar.className = 'yb-mg-bar';
      bar.innerHTML = '<span>You have a booking: <b>' + esc(h.number || r.n) + '</b> · ' + esc(whenTxt(h)) + '</span><a href="' + esc(manageUrl(r.n, r.t)) + '">Change or cancel it</a>';
      wrap.insertBefore(bar, at);
    }).catch(function(e){ if (e && e.status === 404) forget(); });
  }

  var q = new URLSearchParams(location.search), num = q.get('manage'), tok = q.get('t') || '';
  if (!num) { if (!q.get('hold')) offerLast(); return; }

  /* ── Manage mode ── */
  S.flow = null; S.step = 0;
  var M = { h: null, mode: null, ns: null, ne: null, picking: false, off: 0, slotDay: null, msg: '' };
  function clearSteps(){ [].forEach.call(document.querySelectorAll('#yeti-booking .yb-ask, #yb-slotnotice'), function(x){ x.style.display = 'none'; }); var s = document.getElementById('yb-stepper'); if (s) s.innerHTML = ''; var n = document.getElementById('yb-demonote'); if (n) n.innerHTML = ''; }
  function gone(why){
    clearSteps();
    view.innerHTML = '<h1>This booking can’t be changed any more</h1>' +
      '<p class="yb-sub">' + (why ? esc(why) + ' ' : '') + 'It may have been cancelled, picked up, or the link may be out of date. <a href="/pages/contact-details">Message us</a> and we’ll sort it, or <a href="/pages/book">start a new booking</a>.</p>';
  }

  function show(){
    var h = M.h, L = nDays(h.start, h.end);
    clearSteps();
    var bikes = bikeNames(h);
    var cart = '<div class="yb-cart"><h3>' + (bikes.length > 1 ? 'Your bikes' : 'Your bike') + '</h3><div class="yb-when">' + esc(whenTxt(h)) + '</div>' +
      bikes.map(function(b){ return '<div class="yb-ci"><span>' + esc(b) + '</span></div>'; }).join('') +
      '<div class="yb-tot"><span>' + (isFree(h) ? 'Price' : 'Total') + '</span><span>' + esc(paidTxt(h)) + '</span></div>' +
      '<p class="yb-note">Pickup at the Yeti Showroom, 1131 Amohau Street, Rotorua. Bring photo ID.</p></div>';
    var unpaid = h.status === 'hold' ? '<div class="yb-warn">This booking isn’t paid yet, so the bike is only held for a short while. <a href="/pages/book?hold=' + encodeURIComponent(num) + '&t=' + encodeURIComponent(tok) + '">Sign and pay to lock it in</a>.</div>' : '';
    var left = (M.msg ? '<div class="yb-mg-ok">' + M.msg + '</div>' : '') + unpaid;
    if (M.mode === 'move') left += moveHtml(L);
    else if (M.mode === 'cancel') left += cancelHtml();
    else left += '<p class="yb-sub">Can’t make it? Move the booking to another day, or cancel it.</p>' +
      '<div class="yb-mg-acts"><button class="yb-btn" id="mg-move">Change the dates</button><button class="yb-btn ghost" id="mg-cancel">Cancel this booking</button></div>';
    view.innerHTML = '<h1>Your booking ' + esc(h.number || num) + '</h1><p class="yb-sub">' + esc(kindLabel(h)) + ' · ' + esc(h.name || '') + '</p>' +
      '<div class="yb-cols"><div>' + left + '</div><div>' + cart + '</div></div>';
    bind(L);
  }

  /* ── Move ── */
  function moveHtml(L){
    var h = M.h;
    if (h.kind === 'slot') {
      var days = upcomingSlotDays().filter(function(d){ return d !== h.start; });
      return '<div class="yb-mg-panel"><h3>Move your half-day ride</h3>' +
        '<p class="yb-sub" style="margin:0">Same bike, same ' + (String(h.slot_start) < '12:00' ? 'morning' : 'afternoon') + ' slot (' + hm(h.slot_start) + '–' + hm(h.slot_end) + '). Pick another short demos day:</p>' +
        (days.length ? '<div class="yb-mg-slots">' + days.slice(0, 16).map(function(d){ var r = rule(d); return '<button type="button" data-d="' + d + '"' + (M.ns === d ? ' class="on"' : '') + '>' + fmt(d) + (r && r.label ? ' · ' + esc(r.label) : '') + '</button>'; }).join('') + '</div>'
          : '<div class="yb-msg">There are no other short demos days coming up. Cancel instead, or <a href="/pages/contact-details">message us</a>.</div>') +
        '<div id="mg-info"></div>' +
        '<div class="yb-row"><button class="yb-btn ghost" id="mg-back">← Back</button><button class="yb-btn" id="mg-go" style="flex:1"' + (M.ns ? '' : ' disabled') + '>Move it</button></div></div>';
    }
    return '<div class="yb-mg-panel"><h3>Pick your new dates</h3>' +
      '<p class="yb-sub" style="margin:0">' + (L > 1 ? 'Tap the new first day — we keep it ' + L + ' days. Tap a later day to change the last day too.' : 'Tap the new day.') +
      ' Your current ' + (L > 1 ? 'dates are' : 'day is') + ' outlined.</p>' +
      '<div class="yb-mg-nav"><button type="button" id="mg-prev"' + (M.off <= 0 ? ' disabled' : '') + '>‹ Earlier</button><button type="button" id="mg-next"' + (M.off >= 3 ? ' disabled' : '') + '>Later ›</button></div>' +
      '<div class="yb-cal-wrap" id="mg-cal"></div><div id="mg-info"></div>' +
      '<div class="yb-row"><button class="yb-btn ghost" id="mg-back">← Back</button><button class="yb-btn" id="mg-go" style="flex:1" disabled>Move it</button></div></div>';
  }
  function okDay(k){
    var r = rule(k);
    if (dParse(k) < firstBookable()) return false;
    if (r && r.mode === 'closed') return false;
    if (r && r.mode === 'slots' && M.h.kind !== 'hire') return false;
    return true;
  }
  function cal(y, m){
    var el = document.createElement('div'); el.className = 'yb-cal';
    var first = new Date(y, m, 1).getDay(), dim = new Date(y, m + 1, 0).getDate(), h = M.h;
    var html = '<div class="mh">' + new Date(y, m, 1).toLocaleDateString('en-NZ', { month: 'long', year: 'numeric' }) + '</div><div class="yb-dow"><span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span></div><div class="yb-days">';
    for (var i = 0; i < first; i++) html += '<div class="yb-day empty"></div>';
    for (var d = 1; d <= dim; d++) {
      var dt = new Date(y, m, d), k = iso(dt), r = rule(k), cls = 'yb-day', tip = '';
      if (dt < today()) cls += ' past';
      else if (!okDay(k)) { cls += ' mg-off'; tip = dt < firstBookable() ? 'Within 48 hours — message us' : r && r.mode === 'closed' ? 'Closed' : 'Short demos day (half-day slots only)'; }
      if (r && r.mode === 'closed') cls += ' closed';
      if (r && r.mode === 'slots') cls += ' slot';
      if (k >= h.start && k <= h.end) cls += ' mg-old';
      if (M.ns && M.ne && k >= M.ns && k <= M.ne) cls += ' in';
      if (k === M.ns || k === M.ne) cls += ' end';
      html += '<div class="' + cls + '" data-d="' + k + '"' + (tip ? ' title="' + esc(tip) + '"' : '') + '>' + d + '</div>';
    }
    el.innerHTML = html + '</div>';
    [].forEach.call(el.querySelectorAll('.yb-day:not(.empty):not(.past):not(.mg-off)'), function(c){ c.onclick = function(){ pick(c.dataset.d); }; });
    return el;
  }
  function pick(k){
    var L = nDays(M.h.start, M.h.end);
    if (L > 1 && M.picking && M.ns && k > M.ns) { M.ne = k; M.picking = false; }
    else { M.ns = k; M.ne = iso(addD(dParse(k), L - 1)); M.picking = L > 1; }
    drawMove();
  }
  function drawMove(){
    var h = M.h, L = nDays(h.start, h.end), box = document.getElementById('mg-cal'), info = document.getElementById('mg-info'), go = document.getElementById('mg-go');
    if (box) {
      box.innerHTML = '';
      var now = today(), y = now.getFullYear(), m = now.getMonth() + M.off;
      box.appendChild(cal(y + Math.floor(m / 12), m % 12));
      var m2 = m + 1; box.appendChild(cal(y + Math.floor(m2 / 12), m2 % 12));
    }
    if (!info || !go) return;
    go.disabled = true; info.innerHTML = '';
    if (!M.ns) return;
    if (h.kind !== 'slot') {
      var bad = []; for (var d = dParse(M.ns); d <= dParse(M.ne); d = addD(d, 1)) if (!okDay(iso(d))) bad.push(iso(d));
      var n = nDays(M.ns, M.ne);
      info.innerHTML = '<p class="yb-sub" style="margin-top:12px"><b>New dates: ' + esc(M.ns === M.ne ? fmt(M.ns) : fmt(M.ns) + ' → ' + fmt(M.ne)) + '</b> · ' + n + (n === 1 ? ' day' : ' days') +
        (M.picking ? ' · tap a later day to change the last day' : '') + (n === L ? ' · same bikes, same price' : '') + '</p>';
      if (M.ns === h.start && M.ne === h.end) { info.innerHTML += '<div class="yb-note">Those are your current dates.</div>'; return; }
      if (bad.length) { info.innerHTML += '<div class="yb-warn">' + bad.map(fmt).join(', ') + (bad.length > 1 ? ' aren’t' : ' isn’t') + ' available for a full-day booking. Pick other dates.</div>'; return; }
      /* Check the bikes are free — only when the new dates don't overlap this booking, which would count against itself. */
      var overlap = !(M.ne < h.start || M.ns > h.end);
      if (overlap) { go.disabled = false; return; }
      var tag = M.ns + M.ne;
      info.insertAdjacentHTML('beforeend', '<div class="yb-note" id="mg-chk">Checking the ' + (bikeNames(h).length > 1 ? 'bikes are' : 'bike is') + ' free…</div>');
      api('/availability?type=' + (h.kind === 'hire' ? 'hire' : 'demo') + '&start=' + M.ns + '&end=' + M.ne).then(function(r){
        if (M.ns + M.ne !== tag) return;
        var c = document.getElementById('mg-chk'); if (c) c.remove();
        var names = bikeNames(h), busy = names.filter(function(nm){ var f = (r.bikes || []).find(function(b){ return (b.displayName || b.name) === nm; }); return f && f.available === false; });
        if (busy.length) { info.insertAdjacentHTML('beforeend', '<div class="yb-warn">' + busy.map(esc).join(' and ') + (busy.length > 1 ? ' are' : ' is') + ' already booked on those dates. Pick other dates.</div>'); return; }
        go.disabled = false;
      }).catch(function(){ var c = document.getElementById('mg-chk'); if (c) c.remove(); go.disabled = false; });
    } else {
      info.innerHTML = '<div class="yb-note" id="mg-chk">Checking ' + esc(fmt(M.ns)) + '…</div>';
      var day = M.ns;
      api('/slots?day=' + day).then(function(r){
        if (M.ns !== day) return;
        var sl = (r.slots || []).find(function(s){ return s.start === h.slot_start; });
        if (!sl) { info.innerHTML = '<div class="yb-warn">' + esc(fmt(day)) + ' doesn’t have the ' + hm(h.slot_start) + ' slot. Pick another day.</div>'; return; }
        if (!sl.free) { info.innerHTML = '<div class="yb-warn">That slot is fully booked on ' + esc(fmt(day)) + '. Pick another day.</div>'; return; }
        info.innerHTML = '<p class="yb-sub" style="margin-top:12px"><b>New day: ' + esc(fmt(day)) + ', ' + hm(h.slot_start) + '–' + hm(h.slot_end) + '</b> · same bike, same price</p>';
        go.disabled = false;
      }).catch(function(){ info.innerHTML = ''; go.disabled = false; });
    }
  }
  function doMove(btn){
    var h = M.h, L = nDays(h.start, h.end), body = { t: tok, start: M.ns };
    if (h.kind !== 'slot' && (L > 1 || M.ne !== M.ns)) body.end = M.ne;
    btn.disabled = true; btn.textContent = 'Moving…';
    api('/hold/' + encodeURIComponent(num) + '/move', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function(b){
      M.h = (b && b.start) ? b : Object.assign({}, h, { start: M.ns, end: h.kind === 'slot' ? M.ns : M.ne });
      remember(num, tok, M.h.end);
      M.mode = null; M.ns = M.ne = null; M.msg = '<b>Done — your booking is moved.</b> It’s now ' + esc(whenTxt(M.h)) + '. We’ve got the bike' + (bikeNames(M.h).length > 1 ? 's' : '') + ' held for you.';
      show(); try { view.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(e){}
    }).catch(function(e){
      btn.disabled = false; btn.textContent = 'Move it';
      var info = document.getElementById('mg-info'); if (info) info.insertAdjacentHTML('beforeend', '<div class="yb-warn">' + errText(e) + '</div>');
    });
  }

  /* ── Cancel ── */
  function cancelHtml(){
    var h = M.h;
    var after = isFree(h) ? 'Your free-demo code comes back to you, so you can book another day with it.'
      : h.status === 'hold' ? 'Nothing has been charged for this booking.'
      : 'We handle refunds by hand — we’ll be in touch about yours.';
    return '<div class="yb-mg-panel"><h3>Cancel this booking?</h3>' +
      '<p class="yb-sub" style="margin:0">' + esc(whenTxt(h)) + ' · ' + bikeNames(h).map(esc).join(', ') + '. ' + after + '</p>' +
      '<label class="yb-lb" for="mg-why">Tell us why (optional)</label><input class="yb-fi yb-mg-why" id="mg-why" maxlength="300" placeholder="e.g. Can’t make it that weekend">' +
      '<div id="mg-info"></div>' +
      '<div class="yb-row"><button class="yb-btn ghost" id="mg-back">← Keep my booking</button><button class="yb-btn" id="mg-go" style="flex:1">Yes, cancel it</button></div></div>';
  }
  function doCancel(btn){
    var h = M.h, why = (document.getElementById('mg-why') || {}).value || '';
    var body = { t: tok }; if (String(why).trim()) body.why = String(why).trim();
    btn.disabled = true; btn.textContent = 'Cancelling…';
    api('/hold/' + encodeURIComponent(num) + '/cancel', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function(){
      forget(); clearSteps();
      var after = isFree(h) ? '<p class="yb-sub"><b>Your free-demo code is yours again — book another day with it.</b></p>'
        : h.status === 'hold' ? '<p class="yb-sub">Nothing was charged.</p>'
        : '<p class="yb-sub">We handle refunds by hand, so we’ll be in touch about yours.</p>';
      view.innerHTML = '<div class="yb-booked"><h1>Your booking is cancelled</h1>' +
        '<dl><dt>Booking</dt><dd>' + esc(h.number || num) + '</dd><dt>' + (bikeNames(h).length > 1 ? 'Bikes' : 'Bike') + '</dt><dd>' + bikeNames(h).map(esc).join(', ') + '</dd><dt>Was</dt><dd>' + esc(whenTxt(h)) + '</dd></dl>' +
        after + '<p><a class="yb-btn" href="/pages/book">Book another day</a></p></div>';
      try { view.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(e){}
    }).catch(function(e){
      btn.disabled = false; btn.textContent = 'Yes, cancel it';
      var info = document.getElementById('mg-info'); if (info) info.innerHTML = '<div class="yb-warn">' + errText(e) + '</div>';
    });
  }

  function bind(L){
    var $ = function(id){ return document.getElementById(id); };
    if ($('mg-move')) $('mg-move').onclick = function(){ M.mode = 'move'; M.msg = ''; M.ns = M.ne = null; M.picking = false; M.off = 0; show(); };
    if ($('mg-cancel')) $('mg-cancel').onclick = function(){ M.mode = 'cancel'; M.msg = ''; show(); };
    if ($('mg-back')) $('mg-back').onclick = function(){ M.mode = null; show(); };
    if (M.mode === 'move') {
      if ($('mg-prev')) $('mg-prev').onclick = function(){ if (M.off > 0) { M.off--; show(); } };
      if ($('mg-next')) $('mg-next').onclick = function(){ if (M.off < 3) { M.off++; show(); } };
      [].forEach.call(view.querySelectorAll('.yb-mg-slots button'), function(b){ b.onclick = function(){
        M.ns = M.ne = b.dataset.d;
        [].forEach.call(view.querySelectorAll('.yb-mg-slots button'), function(x){ x.classList.toggle('on', x === b); });
        drawMove(); }; });
      if (M.h.kind !== 'slot') drawMove();
      if ($('mg-go')) $('mg-go').onclick = function(){ doMove(this); };
    }
    if (M.mode === 'cancel' && $('mg-go')) $('mg-go').onclick = function(){ doCancel(this); };
  }

  clearSteps();
  view.innerHTML = '<div class="yb-msg">Loading your booking…</div>';
  Promise.all([
    api('/hold/' + encodeURIComponent(num) + '?t=' + encodeURIComponent(tok)),
    (typeof loadDays === 'function' ? loadDays() : Promise.resolve())
  ]).then(function(x){
    var h = x[0];
    if (!h || !h.start || (h.status && h.status !== 'hold' && h.status !== 'confirmed')) return gone();
    M.h = h; remember(num, tok, h.end); show();
  }).catch(function(e){ gone(e && e.status === 404 ? '' : (e && e.message)); });
})();
